import { render, staticRenderFns } from "./soltPhDetail.vue?vue&type=template&id=6c4158fc&scoped=true"
import script from "./soltPhDetail.vue?vue&type=script&lang=js"
export * from "./soltPhDetail.vue?vue&type=script&lang=js"
import style0 from "./soltPhDetail.vue?vue&type=style&index=0&id=6c4158fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4158fc",
  null
  
)

export default component.exports